/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router"

// Import Routes

import { Route as rootRoute } from "./routes/__root.tsx"

// Create Virtual Routes

const AnalyzeLazyImport = createFileRoute("/analyze")()
const IndexLazyImport = createFileRoute("/")()

// Create/Update Routes

const AnalyzeLazyRoute = AnalyzeLazyImport.update({
  id: "/analyze",
  path: "/analyze",
  getParentRoute: () => rootRoute,
} as any).lazy(() => import("./routes/analyze.lazy.tsx").then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any).lazy(() => import("./routes/index.lazy.tsx").then((d) => d.Route))

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    "/analyze": {
      id: "/analyze"
      path: "/analyze"
      fullPath: "/analyze"
      preLoaderRoute: typeof AnalyzeLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  "/": typeof IndexLazyRoute
  "/analyze": typeof AnalyzeLazyRoute
}

export interface FileRoutesByTo {
  "/": typeof IndexLazyRoute
  "/analyze": typeof AnalyzeLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/": typeof IndexLazyRoute
  "/analyze": typeof AnalyzeLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/" | "/analyze"
  fileRoutesByTo: FileRoutesByTo
  to: "/" | "/analyze"
  id: "__root__" | "/" | "/analyze"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AnalyzeLazyRoute: typeof AnalyzeLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AnalyzeLazyRoute: AnalyzeLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/analyze"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/analyze": {
      "filePath": "analyze.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
